import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// NAVBARS
import Navbar from "./components/Navbar/Navbar";
import NavbarEn from "./components/Navbar/NavbarEn";
import NavbarFr from "./components/Navbar/NavbarFr";
import NavbarDE from "./components/Navbar/NavbarDE";
import NavbarHome from "./components/Navbar/NavbarHome";

// CSS
import "./App.css";
import "./components/PDF/css/estilos.css";

// COMPONENTS
import ScrollToTop from "./components/ScrollToTop";
import Home from "./components/pages/Home";
import HomeDE from "./components/pages/HomeDE";
import HomeEn from "./components/pages/HomeEn";
import HomeFr from "./components/pages/HomeFr";

// PT Pages
import Empresa from "./components/pages/Empresa";
import Products from "./components/pages/Products";
import Services from "./components/pages/Services";
import ContactPage from "./components/pages/ContactPage";
import Noticias from "./components/pages/Noticias";
import SignUp from "./components/pages/SignUp";
import Natal from "./components/Postal/Natal";
import Christmas from "./components/Postal/Natal-EN";
import Mailersend from "./components/Mail/Mailersend";
import PDFSender from "./components/PDFCreate/Post";
import Recrut from "./components/Candidaturas/Recrut";
import Emprego from "./components/Emprego/Emprego";
import Upload from "./components/Upload/UploadPage";
import Sendfiles from "./components/Sendfiles/Send";

// EN Pages
import EmpresaEn from "./components/pages/EmpresaEn";
import ProductsEn from "./components/pages/ProductsEn";
import ServicesEn from "./components/pages/ServicesEn";
import ContactPageEn from "./components/pages/ContactPageEn";
import NoticiasEn from "./components/pages/NoticiasEn";

// FR Pages
import EmpresaFr from "./components/pages/EmpresaFr";
import ProductsFr from "./components/pages/ProductsFr";
import ServicesFr from "./components/pages/ServicesFr";
import ContactPageFr from "./components/pages/ContactPageFr";
import NoticiasFr from "./components/pages/NoticiasFr";

// DE Pages
import EmpresaDE from "./components/pages/EmpresaDe";
import ProductsDE from "./components/pages/ProductsDe";
import ServicesDE from "./components/pages/ServicesDe";
import ContactPageDE from "./components/pages/ContactPageDe";
import NoticiasDE from "./components/pages/NoticiasDE";

function App() {
  return (
    <Router>
      <ScrollToTop />

      <Routes>

        {/* ---------------- PT ROUTES ---------------- */}
        <Route
          path="/"
          element={
            <>
              <Navbar />
              <Home />
            </>
          }
        />

        <Route
          path="/Empresa"
          element={
            <>
              <Navbar />
              <Empresa />
            </>
          }
        />

        <Route
          path="/products"
          element={
            <>
              <Navbar />
              <Products />
            </>
          }
        />

        <Route
          path="/services"
          element={
            <>
              <Navbar />
              <Services />
            </>
          }
        />

        <Route
          path="/ContactPage"
          element={
            <>
              <Navbar />
              <ContactPage />
            </>
          }
        />

        <Route
          path="/Noticias"
          element={
            <>
              <Navbar />
              <Noticias />
            </>
          }
        />

        <Route
          path="/sign-up"
          element={
            <>
              <Navbar />
              <SignUp />
            </>
          }
        />

        <Route
          path="/Natal"
          element={
            <>
              <Navbar />
              <Natal />
            </>
          }
        />

        <Route
          path="/Christmas"
          element={
            <>
              <Navbar />
              <Christmas />
            </>
          }
        />

        <Route
          path="/Mailersend"
          element={
            <>
              <Navbar />
              <Mailersend />
            </>
          }
        />

        <Route
          path="/PDFSender"
          element={
            <>
              <Navbar />
              <PDFSender />
            </>
          }
        />

        <Route
          path="/Recrut"
          element={
            <>
              <Navbar />
              <Recrut />
            </>
          }
        />

        <Route
          path="/Emprego"
          element={
            <>
              <Navbar />
              <Emprego />
            </>
          }
        />

        <Route
          path="/UploadPage"
          element={
            <>
              <Navbar />
              <Upload />
            </>
          }
        />

        <Route
          path="/Sendfiles"
          element={
            <>
              <Navbar />
              <Sendfiles />
            </>
          }
        />

        {/* ---------------- EN ROUTES ---------------- */}
        <Route
          path="/HomeEn"
          element={
            <>
              <NavbarEn />
              <HomeEn />
            </>
          }
        />

        <Route
          path="/EmpresaEn"
          element={
            <>
              <NavbarEn />
              <EmpresaEn />
            </>
          }
        />

        <Route
          path="/productsen"
          element={
            <>
              <NavbarEn />
              <ProductsEn />
            </>
          }
        />

        <Route
          path="/servicesEn"
          element={
            <>
              <NavbarEn />
              <ServicesEn />
            </>
          }
        />

        <Route
          path="/ContactPageen"
          element={
            <>
              <NavbarEn />
              <ContactPageEn />
            </>
          }
        />

        <Route
          path="/NoticiasEn"
          element={
            <>
              <NavbarEn />
              <NoticiasEn />
            </>
          }
        />

        {/* ---------------- FR ROUTES ---------------- */}
        <Route
          path="/HomeFr"
          element={
            <>
              <NavbarFr />
              <HomeFr />
            </>
          }
        />

        <Route
          path="/EmpresaFr"
          element={
            <>
              <NavbarFr />
              <EmpresaFr />
            </>
          }
        />

        <Route
          path="/productsFr"
          element={
            <>
              <NavbarFr />
              <ProductsFr />
            </>
          }
        />

        <Route
          path="/servicesFr"
          element={
            <>
              <NavbarFr />
              <ServicesFr />
            </>
          }
        />

        <Route
          path="/ContactPageFr"
          element={
            <>
              <NavbarFr />
              <ContactPageFr />
            </>
          }
        />

        <Route
          path="/NoticiasFr"
          element={
            <>
              <NavbarFr />
              <NoticiasFr />
            </>
          }
        />

        {/* ---------------- DE ROUTES ---------------- */}
        <Route
          path="/HomeDE"
          element={
            <>
              <NavbarDE />
              <HomeDE />
            </>
          }
        />

        <Route
          path="/EmpresaDE"
          element={
            <>
              <NavbarDE />
              <EmpresaDE />
            </>
          }
        />

        <Route
          path="/productsDE"
          element={
            <>
              <NavbarDE />
              <ProductsDE />
            </>
          }
        />

        <Route
          path="/servicesDE"
          element={
            <>
              <NavbarDE />
              <ServicesDE />
            </>
          }
        />

        <Route
          path="/ContactPageDE"
          element={
            <>
              <NavbarDE />
              <ContactPageDE />
            </>
          }
        />

        <Route
          path="/NoticiasDE"
          element={
            <>
              <NavbarDE />
              <NoticiasDE />
            </>
          }
        />

        {/* ROTA INEXISTENTE → Redireciona para Home */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
